export const products = [
  {
    id: 1,
    img: "./img/content/product-1.jpg",
    description: "Набор для путешествий  «Baxter of California»",
    price: 2990,
    category: "shaving"
  },
  {
    id: 2,
    img: "./img/content/product-2.jpg",
    description: "Увлажняющий кондиционер  «Baxter of California»",
    price: 1550,
    category: "shaving"
  },
  {
    id: 3,
    img: "./img/content/product-3.jpg",
    description: "Гель для волос «SUAVECITO»",
    price: 490,
    category: "shaving"
  },
  {
    id: 4,
    img: "./img/content/product-4.jpg",
    description: "Глина для укладки волос  «American crew»",
    price: 990,
    category: "shaving"
  },
  {
    id: 5,
    img: "./img/content/product-5.jpg",
    description: "Гель для волос «AMERICAN CREW»",
    price: 3790,
    category: "shaving"
  },
  {
    id: 5,
    img: "./img/content/product-5.jpg",
    description: "Гель для волос «AMERICAN CREW»",
    price: 3790,
    category: "shaving"
  },
  {
    id: 5,
    img: "./img/content/product-5.jpg",
    description: "Гель для волос «AMERICAN CREW»",
    price: 3790,
    category: "shaving"
  },
  {
    id: 5,
    img: "./img/content/product-5.jpg",
    description: "Гель для волос «AMERICAN CREW»",
    price: 3790,
    category: "shaving"
  },
  {
    id: 6,
    img: "./img/content/product-6.jpg",
    description: "Набор для бритья «Baxter of California»",
    price: 4830,
    category: "shaving"
  },
  {
    id: 6,
    img: "./img/content/product-6.jpg",
    description: "Набор для бритья «Baxter of California»",
    price: 4830,
    category: "shaving"
  }
]
